import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { FC } from 'react'

type ConfirmDialogProps = {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-records-confirm-dialog-title"
    >
      <DialogTitle id="delete-records-confirm-dialog-title">
        削除を実行します。本当によろしいですか？
      </DialogTitle>
      <DialogActions sx={{ padding: 2 }}>
        <Button onClick={onCancel} color="secondary" variant="contained">
          キャンセル
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          削除する
        </Button>
      </DialogActions>
    </Dialog>
  )
}
